import {getAxiosInstance} from "../../../np-rest/rest";
import {snackActions} from "../../../sc-utilities/SnackBar";

export const fetchGroups = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const countRes = await rest.post("/user-groups/count", filterData);
            if (countRes.data.result?.data > 0) {
                let listRes = await rest.post("/user-groups/list", filterData);
                if (listRes.data && !listRes.data.succeeded) {
                    snackActions.snackBar({
                        message: `${listRes && listRes.data && listRes.data.message ? listRes.data.message : "Cannot fetch groups."}`,
                        options: {
                            variant: 'warning'
                        }
                    });
                    return { data: [], count: 0 };
                }
                if (listRes.data && listRes.data.succeeded) {
                    return { data: listRes.data.result.data, count: countRes.data.result.data }
                }
            } else if (!countRes.data || !countRes.data.result) {
                snackActions.snackBar({
                    message: `${countRes && countRes.data && countRes.data.message ? countRes.data.message : "Cannot fetch groups."}`,
                    options: {
                        variant: 'warning'
                    }
                });
            }
            return { data: [], count: 0 };
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch groups."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: [], count: 0 }
        }
    }
}

export const fetchGroup = id => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('/user-groups/load', id);
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data && res.data.message ? res.data.message : "Cannot fetch group."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return {};
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch group."}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

export const fetchAncestorGroups = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('user-groups/ancestor-view-list', params);
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data && res.data.message ? res.data.message : "Cannot fetch groups."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return null;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch groups."}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

export const createGroup = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('/user-groups/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created group.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create group."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

export const editGroup = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/user-groups/update', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated group.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit group."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const deleteGroup = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('/user-groups/delete', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully deleted group.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot delete group."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot delete group."}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const bulkDeleteGroups = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('/user-groups/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                if (res?.data?.result?.data?.failedToDelete && res?.data?.result?.data?.failedToDelete.length>0) {
                    for (const snack of res.data.result.data.failedToDelete) {
                        snackActions.snackBar({
                            message: `${snack.name} - ${snack.message}`,
                            options: {
                                autoHideDuration: 5000,
                                variant: 'warning'
                            }
                        });
                    }
                } else {
                    snackActions.snackBar({
                        message: `Successfully deleted groups.`,
                        options: {
                            variant: 'success'
                        }
                    });
                }
                return
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete groups."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// export const changeGroupOnProduct = params => {
//     const rest = getAxiosInstance();
//     return async () => {
//         try {
//             const res = await rest.post('/products/change-group', params);
//             if (res.data && res.data.succeeded) {
//                 snackActions.snackBar({
//                     message: `Successfully deleted groups.`,
//                     options: {
//                         variant: 'success'
//                     }
//                 });
//                 return
//             }
//             snackActions.snackBar({
//                 message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot change group on product."}`,
//                 options: {
//                     variant: 'warning'
//                 }
//             });
//             return null;
//         } catch (error) {
//             snackActions.snackBar({
//                 message: `${error.message}`,
//                 options: {
//                     variant: 'error'
//                 }
//             });
//             return null;
//         }
//     };
// }
//
// export const changeGroupOnUser = params => {
//     const rest = getAxiosInstance();
//     return async () => {
//         try {
//             const res = await rest.post('/users/change-group', params);
//             if (res.data && res.data.succeeded) {
//                 snackActions.snackBar({
//                     message: `Successfully deleted groups.`,
//                     options: {
//                         variant: 'success'
//                     }
//                 });
//                 return
//             }
//             snackActions.snackBar({
//                 message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot change group on user."}`,
//                 options: {
//                     variant: 'warning'
//                 }
//             });
//             return null;
//         } catch (error) {
//             snackActions.snackBar({
//                 message: `${error.message}`,
//                 options: {
//                     variant: 'error'
//                 }
//             });
//             return null;
//         }
//     };
// }

export const fetchBulkChangeProductsGroup = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('products/change-group', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully changed products group.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk change products group."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const fetchBulkChangeUsersGroup = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/users/change-group', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully changed users group.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk change users group."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const editGroupLicenses = (data) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('/user-groups/update-balance', data);
            if (res.data && res.data.succeeded) {
                if (res.data.result?.data && res.data.result?.data?.errors?.length>0) {
                    for (const snack of res.data.result.data.errors) {
                        snackActions.snackBar({
                            message: snack.message,
                            options: {
                                autoHideDuration: 5000,
                                variant: 'warning'
                            }
                        });
                    }
                } else {
                    snackActions.snackBar({
                        message: 'Successfully updated group licenses!',
                        options: {
                            variant: 'success'
                        }
                    });
                }
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data && res.data.message ? res.data.message : "Cannot update group licenses."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return {};
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot update group licenses."}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    }
}